<template>
  <div class="page">
    <main-menu-bar/>
    <div class="inner">
      <cards-manager/>
    </div>
  </div>
</template>

<script>
import CardsManager from '../cards/CardsManager.vue'
import MainMenuBar from '../nav/MainMenuBar.vue'
export default {
  name: 'CardsPage',
  components: {
    CardsManager,
    MainMenuBar
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/CardsPage.vue